"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskDetailsModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../");
var PersonalContent_1 = require("./content/PersonalContent");
var IncomingContent_1 = require("./content/IncomingContent");
var Wrapper = styled_components_1.default.aside(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n  max-height: calc(100vh - 60px);\n  overflow: auto;\n"], ["\n  max-width: 100%;\n  max-height: calc(100vh - 60px);\n  overflow: auto;\n"])));
var TaskDetailsModal = function (_a) {
    var _b, _c;
    var task = _a.task, closeModal = _a.closeModal, onTaskUpdateSuccess = _a.onTaskUpdateSuccess, onTaskUpdateError = _a.onTaskUpdateError, onTaskStatusUpdateSuccess = _a.onTaskStatusUpdateSuccess;
    var t = (0, react_i18next_1.useTranslation)().t;
    var isPersonal = ((_b = task.created_by) === null || _b === void 0 ? void 0 : _b.id) === ((_c = task.user) === null || _c === void 0 ? void 0 : _c.id);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(__1.Title, __assign({ level: 4 }, { children: t("Tasks.DetailTask") })), isPersonal ? ((0, jsx_runtime_1.jsx)(PersonalContent_1.PersonalContent, { taskForAction: task, onStatusUpdateSuccess: onTaskStatusUpdateSuccess, onSuccess: onTaskUpdateSuccess, onError: onTaskUpdateError, closeModal: closeModal })) : ((0, jsx_runtime_1.jsx)(IncomingContent_1.IncomingContent, { taskForAction: task, onTaskStatusUpdateSuccess: onTaskStatusUpdateSuccess }))] }));
};
exports.TaskDetailsModal = TaskDetailsModal;
var templateObject_1;
